import ScrollBodyBackground from './ScrollBodyBackground';

export default ScrollBodyBackground;
